import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../contexts/app.context';
import { Button, Input, Text } from '../components';
import { login } from '../service';
import { toast } from 'react-toastify';

const Home = () => {
  const { t } = useTranslation();
  const { setBaseContainerConfig } = useContext(AppContext);

  const [emailValue, setEmailValue] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setBaseContainerConfig({
      heading: '',
      subHeading: '',
      buttonText: '',
      buttonURL: '',
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);
      setSuccess(false);
      await login({ email: emailValue });
      setError(false);
      setSuccess(true);
      toast.success(t('login.success'));
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="text-center mt-20">
        <Text type={'big'} text={t('login.heading')} />
        <Text type={'small'} text={t('login.subHeading')} />
      </div>

      <form
        onSubmit={handleSubmit}
        className="mt-12 w-full max-w-xl mx-auto flex flex-col md:flex-row gap-4 justify-center items-center">
        <div className="flex-1 w-full">
          <Input
            type={'text'}
            htmlType={'email'}
            name="email"
            id="email"
            placeholder={t('login.emailPlaceholder')}
            inputClassName={'!bg-gray-20 px-8 py-4 w-full h-[58px]'}
            defaultValue={emailValue}
            onChange={(e) => setEmailValue(e.target.value)}
          />
        </div>
        <Button
          type={'submit'}
          text={t('login.submit')}
          className={'w-full md:w-auto font-bold tracking-wide text-base px-8 !py-4 h-[58px]'}
          loading={submitting}
        />
      </form>
      {error && (
        <Text type={'xsmall'} text={t('login.error')} className={'text-center text-red-20 mt-2'} />
      )}
      {success && (
        <Text
          type={'xsmall'}
          text={t('login.success')}
          className={'text-center text-blue-20 mt-2'}
        />
      )}
    </>
  );
};

export default Home;
